<cac-dialog-layout title="Add New Image" submitBtn="Add" (onSubmit)="onSubmit($event)">
    <cac-image-uploader [control]="controller" [options]="options" class="h-44" label="Image" />
</cac-dialog-layout>
